module.exports = "span{\n    color:red;\n    font-size: 12px;\n}\n.pwd-input span{\n    color: dimgray;\n    cursor: pointer;\n    padding: 4px 9px;\n}\n.pwd-input span.active{\n    color: #0a5894;\n    cursor: pointer;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/myprofile/changepassword/changepassword.component.css
// module id = ./src/app/myprofile/changepassword/changepassword.component.css
// module chunks = main